import { render, staticRenderFns } from "./allconfig.vue?vue&type=template&id=621b757a&scoped=true&"
import script from "./allconfig.vue?vue&type=script&lang=js&"
export * from "./allconfig.vue?vue&type=script&lang=js&"
import style0 from "./allconfig.vue?vue&type=style&index=0&id=621b757a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b757a",
  null
  
)

export default component.exports